import * as WarehouseDenialCausesActions from './warehouseDenialCauses';
import * as ManualsOrdersActions from './manualsOrders';
import * as StoragePending from './storagePending';
import * as LocationsActions from './locations';
import * as DashboardActions from './dashboard';
import * as ScanningActions from './scanning';
import * as ShiftsActions from './shifts';
import * as ZonesActions from './zones';

const Actions = {
  ...ScanningActions,
  ...WarehouseDenialCausesActions,
  ...ShiftsActions,
  ...ZonesActions,
  ...LocationsActions,
  ...StoragePending,
  ...ManualsOrdersActions,
  ...DashboardActions,
};

export default Actions;
